import type { SimpleBoard } from "../levelgenerator/simpleBoard";
import { PhysicalThing } from "../physicalThing";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { ZOrder } from "../zOrder";

export class Text extends PhysicalThing {
	static key = "Text";
	readonly textKey: string;
	readonly color: string;

	constructor(xy: XY, textKey: string, color: string = "#bbbbbb") {
		super(xy, false);
		this.textKey = textKey;
		this.color = color;
	}

	getZOrder(): number {
		return ZOrder.SCENARIO;
	}

	serialize(): Record<string, unknown> {
		return {
			...super.serialize(),
			textKey: this.textKey,
			color: this.color,
		};
	}

	static deserialize(data: any): Text {
		const t = new Text(deserializeXY(data.xy), data.textKey, data.color);
		t.visualId = data.visualId;
		return t;
	}

	static override initOnBoard(xy: XY, board: SimpleBoard, props?: Record<string, unknown>): PhysicalThing[] {
		const textKey = typeof props?.textKey === "string" ? props.textKey : "text_default";
		const color = typeof props?.color === "string" ? props.color : "#bbbbbb";
		const text = new Text(xy, textKey, color);
		board.putThing(text);
		return [text];
	}
}
